<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="router-view"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="router-view"></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
}

html {
  color: #000;
  overflow-y: auto;
  overflow: -moz-scrollbars;
}

body,
button,
input,
select,
textarea {
  font: 12px arial;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
}

em {
  font-style: normal;
}

small {
  font-size: 12px;
}

ul,
ol {
  list-style: none;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

legend {
  color: #000;
}

fieldset,
img {
  border: 0;
}

button,
input,
select,
textarea {
  font-size: 100%;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

img {
  -ms-interpolation-mode: bicubic;
}

textarea {
  resize: vertical;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 0px;
  margin: 0px;
  min-width: 1024px;
  max-width: 100%;
  min-height: 768px;
  max-height: 100%;
}
/* element样式修改 */
.el-menu {
  border: none;
  font-size: 16px;
}
/**二级菜单样式 */
.el-menu-item {
  background: #fff;
  font-size: 14px;
  margin-left: 42px;
}
.el-menu-item-group__title {
  padding: 0 !important;
}
.el-menu-item > i {
  color: #3B475D !important;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background: #fff !important;
}
/**二级菜单点击样式 */
.el-menu-item.is-active {
  color:#000000 !important;
  font-weight: bold;
}
/**鼠标悬浮菜单样式 */
.el-submenu__title:hover {
  background: #fff !important;
  color:#0070E0 !important;
}

/**二级菜单三角号点击样式 */
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  color: #444 !important;
}
/**一级菜单样式 */
.el-submenu__title {
  font-size: 16px;
  margin-left: 30px;
}

.el-submenu__title i {
  color: #3B475D !important;
}
/* 分页器 */
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #0070E0 !important;
}
.el-button {
  padding: 9px 10px !important;
}
.el-icon-loading:before {
  font-size: 24px;
}
.el-table--scrollable-y .el-table__body-wrapper {
  height: auto !important;
}
.el-menu-item-group>ul{
  overflow-x: hidden!important;
}
.el-input__inner{
  border-radius: 0!important;
}
.el-table {
 border: 1px solid #E6E8EB; 
}

</style>



// WEBPACK FOOTER //
// src/App.vue